// Admin auth slice. Tracks the logged-in admin and the in-flight states for
// login / logout / session-check. `checked` flips true once we've asked the
// server who we are, so the route guard can avoid redirecting on first paint.
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { adminFetch } from '../api/admin-client.js';

export const fetchAdminMe = createAsyncThunk(
  'adminAuth/me',
  async (_arg, { rejectWithValue }) => {
    try {
      const { user } = await adminFetch('/api/admin/auth/me');
      return user;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const loginAdmin = createAsyncThunk(
  'adminAuth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const { user } = await adminFetch('/api/admin/auth/login', {
        method: 'POST',
        body: credentials,
      });
      return user;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const logoutAdmin = createAsyncThunk('adminAuth/logout', async () => {
  await adminFetch('/api/admin/auth/logout', { method: 'POST' });
  return null;
});

const initialState = {
  user: null,
  checked: false,
  loading: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    // Called when an API request comes back 401 so the UI drops to the login screen.
    clearAdminSession: (s) => {
      s.user = null;
      s.checked = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminMe.fulfilled, (s, a) => {
        s.user = a.payload;
        s.checked = true;
      })
      .addCase(fetchAdminMe.rejected, (s) => {
        s.user = null;
        s.checked = true;
      })
      .addCase(loginAdmin.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(loginAdmin.fulfilled, (s, a) => {
        s.loading = false;
        s.user = a.payload;
        s.checked = true;
      })
      .addCase(loginAdmin.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload || 'Sign in failed. Please try again.';
      })
      .addCase(logoutAdmin.fulfilled, (s) => {
        s.user = null;
        s.checked = true;
      });
  },
});

export const { clearAdminSession } = adminAuthSlice.actions;
export const selectAdminUser = (state) => state.adminAuth.user;
export default adminAuthSlice.reducer;
